import { IAppState } from '../store';
import { IUserLevelInfo } from '../types/agentCard';

export const selectAgentLevelInfo = (state: IAppState): IUserLevelInfo | undefined | null =>
  state.realtor.moderationInfo?.userLevelInfo;
